import {
  FastLettersGame,
  FromMemoryGame,
  GuidedTraceGame,
  MysteryLetterGame,
  WatchAndTapGame,
  WhichIsRightGame,
  WordInSentenceGame,
} from "./FoundationGames";
import {
  BigAndSmallGame,
  BigOrSmallGame,
  CapitalFromMemoryGame,
  CapitalWhereGame,
  CurveCapitalsGame,
  FastCapitalsGame,
  FixTheStartGame,
  MyCapitalGame,
  NameStartsBigGame,
  PairWritingGame,
  StraightLineCapitalsGame,
} from "./CapitalGames";
import {
  BigLetterFirstGame,
  CharacterInSentenceGame,
  MeetTheCastGame,
  MyProfileNameGame,
  NameScrambleGame,
  NameSprintGame,
  NameTagsGame,
  SignMyBookGame,
  TraceTheCastGame,
  WhoIsItGame,
} from "./NameGames";
import {
  ArrowNumbersGame,
  CountAndWriteGame,
  FastNumbersGame,
  NumberInSentenceGame,
  NumberWordsGame,
} from "./NumberGames";
import {
  ChangeOneSoundGame,
  FirstAndLastGame,
  SentenceChoiceGame,
  SoundLadderGame,
  SoundToLetterGame,
  StretchAndWriteGame,
  WhichSoundGame,
  WordBuilderGame,
  WordWallGame,
} from "./SoundGames";
import {
  CapitalAndStopGame,
  FrameFadeGame,
  JoinSentencesGame,
  OneMoreGame,
  PickThenWriteGame,
  PictureSentenceGame,
  ThreeWaysGame,
  TodaysSentenceGame,
  UntangleGame,
  WhoAndThatGame,
  WordSprintGame,
} from "./SentenceGames";
import {
  AddToMyStoryGame,
  DraftWithMeterGame,
  EndingsTwoWaysGame,
  FindThePartGame,
  GrowOneSentenceGame,
  IntoMyBookGame,
  MeetPOWGame,
  MyOrganizerGame,
  OrderItGame,
  PandaPlansGame,
  PartDetectiveGame,
  PartWordsGame,
  PartsSortGame,
  ReaderReplyGame,
  SequentialWriteGame,
  SetMyGoalGame,
  ThreeQuestionsGame,
} from "./StoryGames";

export const WRITING_ENGINE_MAP = {
  watchAndTap: WatchAndTapGame,
  guidedTrace: GuidedTraceGame,
  fromMemory: FromMemoryGame,
  whichIsRight: WhichIsRightGame,
  mysteryLetter: MysteryLetterGame,
  fastLetters: FastLettersGame,
  wordInSentence: WordInSentenceGame,
  myCapital: MyCapitalGame,
  straightLineCapitals: StraightLineCapitalsGame,
  capitalFromMemory: CapitalFromMemoryGame,
  bigAndSmall: BigAndSmallGame,
  fastCapitals: FastCapitalsGame,
  curveCapitals: CurveCapitalsGame,
  pairWriting: PairWritingGame,
  bigOrSmall: BigOrSmallGame,
  capitalWhereItBelongs: CapitalWhereGame,
  nameStartsBig: NameStartsBigGame,
  fixTheStart: FixTheStartGame,
  myProfileName: MyProfileNameGame,
  meetTheCast: MeetTheCastGame,
  traceTheCast: TraceTheCastGame,
  nameScramble: NameScrambleGame,
  whoIsIt: WhoIsItGame,
  nameTags: NameTagsGame,
  bigLetterFirst: BigLetterFirstGame,
  characterInSentence: CharacterInSentenceGame,
  nameSprint: NameSprintGame,
  signMyBook: SignMyBookGame,
  arrowNumbers: ArrowNumbersGame,
  countAndWrite: CountAndWriteGame,
  fastNumbers: FastNumbersGame,
  numberInSentence: NumberInSentenceGame,
  numberWords: NumberWordsGame,
  soundToLetter: SoundToLetterGame,
  whichSound: WhichSoundGame,
  firstAndLast: FirstAndLastGame,
  soundLadder: SoundLadderGame,
  changeOneSound: ChangeOneSoundGame,
  stretchAndWrite: StretchAndWriteGame,
  wordBuilder: WordBuilderGame,
  wordWall: WordWallGame,
  sentenceChoice: SentenceChoiceGame,
  pickThenWrite: PickThenWriteGame,
  frameFade: FrameFadeGame,
  todaysSentence: TodaysSentenceGame,
  capitalAndStop: CapitalAndStopGame,
  oneMore: OneMoreGame,
  threeWays: ThreeWaysGame,
  joinSentences: JoinSentencesGame,
  whoAndThat: WhoAndThatGame,
  untangle: UntangleGame,
  pictureSentence: PictureSentenceGame,
  wordSprint: WordSprintGame,
  partWords: PartWordsGame,
  findThePart: FindThePartGame,
  sequentialWrite: SequentialWriteGame,
  orderIt: OrderItGame,
  endingsTwoWays: EndingsTwoWaysGame,
  addToMyStory: AddToMyStoryGame,
  meetPOW: MeetPOWGame,
  partDetective: PartDetectiveGame,
  partsSort: PartsSortGame,
  pandaPlansOutLoud: PandaPlansGame,
  myOrganizer: MyOrganizerGame,
  setMyGoal: SetMyGoalGame,
  draftWithMeter: DraftWithMeterGame,
  threeQuestions: ThreeQuestionsGame,
  growOneSentence: GrowOneSentenceGame,
  intoMyBook: IntoMyBookGame,
  readerReply: ReaderReplyGame,
};
